/**
 * YouTube URL에서 비디오 ID 추출
 */
export const extractYouTubeId = (url: string): string | null => {
  const trimmed = String(url ?? '').trim();
  if (!trimmed) return null;

  try {
    const parsed = new URL(trimmed);
    const host = parsed.hostname.replace(/^www\./, '');
    let id = '';

    if (host === 'youtu.be') {
      id = parsed.pathname.slice(1);
    } else if (host.includes('youtube.com')) {
      if (parsed.pathname.startsWith('/embed/')) {
        id = parsed.pathname.split('/')[2] || '';
      } else if (parsed.pathname.startsWith('/shorts/')) {
        id = parsed.pathname.split('/')[2] || '';
      } else if (parsed.pathname.startsWith('/live/')) {
        id = parsed.pathname.split('/')[2] || '';
      } else {
        id = parsed.searchParams.get('v') || '';
      }
    }

    return id.length === 11 ? id : null;
  } catch {
    // URL 파싱에 실패한 경우 레거시 정규식으로 한 번 더 시도
    const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|shorts\/|live\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = trimmed.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  }
};

/**
 * YouTube URL로부터 썸네일 이미지 URL 반환 (프로젝트/새소식 카드·카카오 공유용)
 * 영상일 때 이미지 대체가 아니라 썸네일을 함께 사용할 때 활용.
 */
export type YouTubeThumbnailQuality =
  | 'default'
  | 'mqdefault'
  | 'hqdefault'
  | 'sddefault'
  | 'maxresdefault';

export const getYouTubeThumbnail = (
  url?: string,
  quality: YouTubeThumbnailQuality = 'hqdefault',
): string | null => {
  if (!url || typeof url !== 'string') return null;
  const videoId = extractYouTubeId(url.trim());
  return videoId ? `https://img.youtube.com/vi/${videoId}/${quality}.jpg` : null;
};

/**
 * YouTube URL을 iframe 임베드 URL로 변환
 */
export const getYouTubeEmbedUrl = (url?: string): string => {
  const trimmed = String(url ?? '').trim();
  if (!trimmed) return '';

  try {
    const parsed = new URL(trimmed);
    const host = parsed.hostname.replace('www.', '');
    let id = '';

    if (host === 'youtu.be') {
      id = parsed.pathname.slice(1);
    } else if (host.includes('youtube.com')) {
      if (parsed.pathname.startsWith('/embed/')) {
        id = parsed.pathname.split('/')[2] || '';
      } else if (parsed.pathname.startsWith('/shorts/')) {
        id = parsed.pathname.split('/')[2] || '';
      } else {
        id = parsed.searchParams.get('v') || '';
      }
    }

    return id ? `https://www.youtube.com/embed/${id}` : '';
  } catch {
    return '';
  }
};
